namespace GeniuzPOS.Purchase {
    export namespace PoPurOrderService {
        export const baseUrl = 'Purchase/PoPurOrder';

        export declare function Create(request: Serenity.SaveRequest<PoPurOrderRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PoPurOrderRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetNextNumber(request: GetNextNumberRequest, onSuccess?: (response: GetNextNumberResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PoPurOrderRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PoPurOrderRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function UpdateCancelAndUseFg(request: UpdateCancelAndUseFgRequest, onSuccess?: (response: Serenity.ServiceResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/PoPurOrder/Create",
            Update = "Purchase/PoPurOrder/Update",
            Delete = "Purchase/PoPurOrder/Delete",
            GetNextNumber = "Purchase/PoPurOrder/GetNextNumber",
            Retrieve = "Purchase/PoPurOrder/Retrieve",
            List = "Purchase/PoPurOrder/List",
            UpdateCancelAndUseFg = "Purchase/PoPurOrder/UpdateCancelAndUseFg"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'GetNextNumber', 
            'Retrieve', 
            'List', 
            'UpdateCancelAndUseFg'
        ].forEach(x => {
            (<any>PoPurOrderService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
